import React, { useEffect, useState } from 'react';
import { Blacked } from "../../../../CRM/components/styles";
import { ReactComponent as ModalCloseIcon } from "../../../../assets/HomeTownIcon/ModalCloseIcon.svg";
import styled from "styled-components";
import { MEDIA_URL } from "../../../../app/constants/APIKEYS";
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import {AutoPlayVideo} from "../../../Common/AutoPlayVideo";



pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

// ------- 파일 타입 헬퍼 -------
const getUrl = (u?: string) => (u ? `${MEDIA_URL}${u}` : '');

const isPdf = (url?: string) => !!url && /\.pdf(\?|#|$)/i.test(url);

// “어지간한” 동영상 확장자 커버 (대소문자/쿼리스트링 포함)
const isVideo = (url?: string) =>
    !!url &&
    /\.(mp4|webm|ogg|ogv|mov|m4v)(\?|#|$)/i.test(url);

// 이미지로 간주할 확장자(필요 시 추가)
const isImage = (url?: string) =>
    !!url && /\.(png|jpe?g|gif|bmp|webp|svg)(\?|#|$)/i.test(url);

export const PreviewMonitor = ({ setIsPreviewModal, itemId, advertiserADList }) => {
  const [selectedItem, setSelectedItem] = React.useState<any[]>([]);

  useEffect(() => {
    if (!advertiserADList || advertiserADList.length === 0) {
      setSelectedItem([]);
      return;
    }

    if (itemId) {
      const matched = advertiserADList?.find((item: any) => item.adId === itemId);
      setSelectedItem(matched?.fileList ?? []);
    } else {
      // 전체가 파일리스트 형태라면 맞춰서 사용
      setSelectedItem(advertiserADList);
    }
  }, [advertiserADList, itemId]);

  useEffect(() => {
    // console.log('selectedItem', selectedItem);
  }, [selectedItem]);

  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages);
  }

  // 첫 번째 아이템 기준으로 미리보기
  const firstUrl: string | undefined = selectedItem?.[0]?.url;
  const firstFile = getUrl(firstUrl);

  return (
      <>
        <Blacked onClick={() => setIsPreviewModal(false)} />
        <ModalWrapper className={"scroll-container"}>
          <ModalHeader>
            <ModalTitle>미리보기</ModalTitle>
            <CloseIconSVG as={ModalCloseIcon} onClick={() => setIsPreviewModal(false)} />
          </ModalHeader>

          {/* ===== 전면 ===== */}
          <Contents>
            <MonitorTitle>전면</MonitorTitle>
            <MonitorWrapper style={{ display: 'flex', justifyContent: 'center' }}>
              {isPdf(firstUrl) ? (
                  <Document file={firstFile} options={options} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} height={230} />
                  </Document>
              ) : isVideo(firstUrl) ? (
                  <AutoPlayVideo
                      src={firstFile}
                      controls={false}
                  />
              ) : (
                  <FullImg src={firstFile} />
              )}
            </MonitorWrapper>
          </Contents>

          {/* ===== 2면 ===== */}
          <Contents>
            <MonitorTitle>2면</MonitorTitle>
            <MonitorWrapper style={{ padding: 4 }}>
              <div style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                {isPdf(firstUrl) ? (
                    <Document file={firstFile} options={options} onLoadSuccess={onDocumentLoadSuccess}>
                      <div style={{ width: 198, display: 'flex', justifyContent: 'center', backgroundColor: '#D9D9D9' }}>
                        <Page pageNumber={pageNumber} height={142} />
                      </div>
                    </Document>
                ) : isVideo(firstUrl) ? (
                    <div style={{ width: 198, display: 'flex', justifyContent: 'center', height: 142.01, backgroundColor: '#D9D9D9' }}>
                      <AutoPlayVideo
                          src={firstFile}
                          controls={false}
                      />
                    </div>
                ) : (
                    <TwoBigImg src={firstFile} />
                )}
                <TwoBig />
              </div>

              <div style={{ display: "flex", justifyContent: "center", gap: 5, marginTop: 5 }}>
                <TwoSmall />
                <TwoSmall />
                <TwoSmall />
                <TwoSmall />
              </div>
            </MonitorWrapper>
          </Contents>

          {/* ===== 6면 ===== */}
          <Contents>
            <MonitorTitle>6면</MonitorTitle>
            <MonitorWrapper style={{ padding: 4 }}>
              <div style={{ display: "flex", justifyContent: "center", gap: 3 }}>
                {isPdf(firstUrl) ? (
                    <Document file={firstFile} options={options} onLoadSuccess={onDocumentLoadSuccess}>
                      <div style={{ width: 133, display: 'flex', justifyContent: 'center', backgroundColor: '#D9D9D9' }}>
                        <Page pageNumber={pageNumber} height={111.55} />
                      </div>
                    </Document>
                ) : isVideo(firstUrl) ? (
                    <div style={{ width: 133, display: 'flex', justifyContent: 'center', height: 111.55, backgroundColor: '#D9D9D9' }}>
                      <AutoPlayVideo
                          src={firstFile}
                          controls={false}
                      />
                    </div>
                ) : (
                    <SixImg src={firstFile} />
                )}
                <SixBox />
                <SixBox />
              </div>

              <div style={{ display: "flex", justifyContent: "center", gap: 3, marginTop: 3 }}>
                <SixBox />
                <SixBox />
                <SixBox />
              </div>
            </MonitorWrapper>
          </Contents>

        </ModalWrapper>
      </>
  );
};

// ================= styled =================
const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 820px;
  overflow-y: scroll;
  width: 580px;
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CloseIconSVG = styled.svg`
  width: 24px;
  cursor: pointer;
`;

const ModalTitle = styled.div`
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 21.48px;
  color: #2E2559;
`;

const Contents = styled.div`
  margin-top: 45px;
  font-weight: 400;
  font-size: 15px;
  line-height: 17.9px;
  font-family: Pretendard, sans-serif;
  color: #000000;
  white-space: pre-wrap;
  text-align: center;
`;

const MonitorTitle = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 17.9px;
  font-family: pretendard, sans-serif;
  margin-bottom: 10px;
`;

const MonitorWrapper = styled.div`
  border: 12.87px solid #000000;
  width: 437.61px;
  height: 257.42px;
`;

const FullImg = styled.img`
  background-color: #D9D9D9;
  width: 100%;
  height: 100%;
`;

const TwoBigImg = styled.img`
  background-color: #D9D9D9;
  width: 198px;
  height: 142.01px;
`;

const TwoBig = styled.div`
  background-color: #D9D9D9;
  width: 198px;
  height: 142.01px;
`;

const TwoSmall = styled.img`
  background-color: #D9D9D9;
  width: 96.96px;
  height: 77.01px;
`;

const SixImg = styled.img`
  background-color: #D9D9D9;
  width: 133px;
  height: 111.55px;
`;

const SixBox = styled.div`
  background-color: #D9D9D9;
  width: 133px;
  height: 111.55px;
`;
